<template>
    <button type="button" class="go-top" @click="goTopBtn()">
<!-- <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none">
    <g filter="url(#filter0_d_831_29665)">
        <rect x="0" y="0" width="72" height="72" rx="36" fill="white" shape-rendering="crispEdges" />
        <rect x="0.5" y="0.5" width="71" height="71" rx="35.5" stroke="#D9D9D9" shape-rendering="crispEdges" />
        <path d="M28 38L36 30L44 38" stroke="#111111" stroke-width="2"/>
    </g>
</svg> -->
    <img src="../../../assets/resource/icon/goTop-arrow2.png" alt="">




    </button>
</template>
<script>
    export default {
        mounted() {
            this.observeFooter();
        },
        methods: {
        goTopBtn() {
          // 1단계: overflow hidden으로 관성 스크롤을 강제로 끊는다
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';

          requestAnimationFrame(() => {
            // 2단계: overflow 복구 + 스냅 끄기
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
            document.documentElement.style.scrollSnapType = 'none';

            void document.documentElement.offsetHeight;

            requestAnimationFrame(() => {
              // 3단계: 이제 안전하게 스크롤 실행
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });

              this.waitForScrollEnd(() => {
                document.documentElement.style.scrollSnapType = '';
              });
            });
          });
        },

      waitForScrollEnd(callback) {
        let lastY = window.scrollY;
        let stableCount = 0;

        const check = () => {
          const currentY = window.scrollY;
          if (currentY === lastY) {
            stableCount++;
            if (stableCount > 3) {
              callback();
              return;
            }
          } else {
            stableCount = 0;
            lastY = currentY;
          }
          requestAnimationFrame(check);
        };

        requestAnimationFrame(check);
      },

            observeFooter() {
                const cont = document.querySelector('.container');
                const goTopButton = document.querySelector('.go-top');

                // IntersectionObserver 콜백 함수
                const callback = (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            // cont의 하단이 뷰포트에 보이면 active 클래스 추가
                            goTopButton.classList.add('active');
                        } else {
                            // cont의 하단이 뷰포트에서 벗어나면 active 클래스 제거
                            goTopButton.classList.remove('active');
                        }
                    });
                };

                // IntersectionObserver 생성
                this.observer = new IntersectionObserver(callback, {
                    root: null, // 뷰포트를 기준으로 감지
                    threshold: 1.0, // cont의 하단이 완전히 보일 때 이벤트 트리거
                });

                // cont 요소의 하단을 감지 대상으로 설정
                const contBottom = document.createElement('div');
                contBottom.style.position = 'absolute';
                contBottom.style.bottom = '0';
                contBottom.style.width = '100%';
                contBottom.style.height = '1px'; // 높이는 필요에 따라 조정
                cont.appendChild(contBottom);
                this.observer.observe(contBottom);
            },
        }
    }
</script>